import {Grid} from "@mui/material";
import Tarjeta_Proyecto from "../../Tarjetas/Tarjeta_Proyecto";
import {Splide, SplideSlide} from '@splidejs/react-splide';
import '@splidejs/react-splide/css/core';
import proyecto1 from '../../../../Recursos/proyecto1.png'
import proyecto2 from '../../../../Recursos/proyecto2.png'
import proyecto3 from '../../../../Recursos/proyecto3.png'
import proyecto4 from '../../../../Recursos/proyecto4.png'
import proyecto5 from '../../../../Recursos/proyecto5.png'
import proyecto6 from '../../../../Recursos/proyecto6.png'


const Lista_Proyectos = ({items = []}) => {

    return (

        <Grid container spacing={3} size={{xs: 12, sm: 12, md: 12}}>


            {items.map((item, index) => (

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <Tarjeta_Proyecto
                        imagen={item.imagen}
                        tipo={item.tipo}
                        titulo={item.titulo}
                        descripcion={item.descripcion}
                        link={item.link}
                    />
                </Grid>


            ))}


        </Grid>

    )

}
export default Lista_Proyectos;